import { css } from 'styled-components';

import colors from '../colors';

const primary = css`
  background: ${colors.buttonPrimary};
  border: 1px solid ${colors.buttonPrimary};
  color: ${colors.buttonText};

  &:hover,
  &:active {
    background-color: ${colors.buttonPrimaryHover};
    border-color: ${colors.buttonPrimaryHover};
  }
`;

const secondary = css`
  background: ${colors.buttonSecondary};
  border: 1px solid ${colors.buttonSecondaryBorder};
  color: ${colors.buttonSecondaryText};

  &:hover,
  &:active {
    background: ${colors.buttonSecondaryHover};
  }
`;

const success = css`
  background: ${colors.buttonSuccess};
  border: 1px solid ${colors.buttonSuccess};
  color: ${colors.buttonText};

  &:hover,
  &:active {
    background-color: ${colors.buttonSuccessHover};
    border-color: ${colors.buttonSuccessHover};
  }
`;

const danger = css`
  background: ${colors.buttonDanger};
  border: 1px solid ${colors.buttonDanger};
  color: ${colors.buttonText};

  &:hover,
  &:active {
    background-color: ${colors.buttonDangerHover};
    border-color: ${colors.buttonDangerHover};
  }
`;

const variants = {
  primary,
  secondary,
  success,
  danger,
};

export default variants;
